// @flow
import { API } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { CustomRole } from 'types/custom-role'

export async function getTeamRoles(teamId: string): Promise<Array<CustomRole>> {
  return await makeGetRequest(API.PERMISSIONS.MEMBERSHIP_GROUPS)
}

export const KEEP_ME = 'KEEP_ME'
